<template>


    <AppLayout>
        <div v-if="$page.props.auth.roles[0] !== 'admin'">
            <div class="container-fluid">
                <div class="row p-19">
                    <div class="col-md-12">
                        <div class="row">

                            <div class="col-md-4">
                            </div>
                            <div class="col-md-4">
                                <div class="jumbotron">
                                    <h1 class="text-center text-danger">
                                        Atención!!!
                                    </h1>
                                    <br>

                                    <h3 class="text-center">
                                        Acceso denegado
                                    </h3>
                                    <p class="text-center">
                                        No tiene permisos para acceder
                                    </p>
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <br>


                                </div>
                            </div>
                            <div class="col-md-4">
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div v-if="$page.props.auth.roles[0] === 'admin'">
            <div class="row g-7 pb-20">
                <div class="col-xl-6">
                    <div class="card card-flush h-lg-100" id="kt_contacts_main">

                        <div class="card-header pt-7" id="kt_chat_contacts_header">
                            <div class="card-title">
                                <span class="svg-icon svg-icon-1 me-2">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                                            fill="currentColor" />
                                        <path opacity="0.3"
                                            d="M17 22divC2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                                            fill="currentColor" />
                                    </svg>
                                </span>
                                <h2>Ingrese los datos</h2>
                            </div>
                        </div>

                        <div class="card-body pt-5">
                            <form @submit.prevent="submit()" class="form">

                                <div class="fv-row mb-7">
                                    <label class="fs-6 fw-semibold form-label mt-3">
                                        <span class="required">Nombre</span>
                                    </label>

                                    <input type="text" class="form-control form-control-solid" :class="{ 'is-invalid': errors.name }" v-model="form.name" />

                                    <div class="invalid-feedback" v-if="errors.name">
                                        {{ errors.name }}
                                    </div>
                                </div>

                                <div class="fv-row mb-7">
                                    <label class="fs-6 fw-semibold form-label mt-3">
                                        <span class="required">Categoría principal</span>
                                    </label>

                                    <select class="form-control form-control-solid"
                                        :class="{ 'is-invalid': errors.category_id }" v-model="form.category_id">
                                        <option v-for="category in categories" :key="category.id" :value="category.id">
                                            {{ category.name }}</option>
                                    </select>
                                    <div class="invalid-feedback" v-if="errors.category_id">
                                        {{ errors.category_id }}
                                    </div>
                                </div>

                                <div class="fv-row mb-7">
                                    <label class="fs-6 fw-semibold form-label mt-3">
                                        <span class="required">Imagen</span>
                                    </label>

                                    <input type="file" class="form-control form-control-solid"
                                        @input="form.file = $event.target.files[0]">
                                </div>

                                <div class="separator mb-6"></div>

                                <div class="d-flex justify-content-end">
                                    <Link :href="route('categories.index')" data-kt-contacts-type="cancel"
                                        class="btn btn-light me-3">Cancelar</Link>

                                    <button type="submit" class="btn btn-primary">Guardar</button>
                                </div>

                            </form>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row pb-20"></div>
            <div class="row pb-20"></div>
            <div class="row pb-20"></div>
        </div>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/Layouts/AppLayout'
import { useForm } from '@inertiajs/inertia-vue3'
import { defineProps } from 'vue';

defineProps({
    errors: Object,
    categories: Array
})

const form = useForm({
    name: null,
    file: null,
    category_id: null
});

const submit = () => {
    form.post(route('categories.store'), {
        onSuccess: () => {
            Swal.fire({
                text: '¡El formulario ha sido enviado con éxito!',
                icon: 'success',
                buttonsStyling: false,
                confirmButtonText: '¡Ok, genial!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
            });
        },
    });
};
</script>
